interface Member {
  name: string;
  description: string;
  credentials: string[];
  image: string;
}

export const members: Array<Member> = [
  {
    name: 'Prof. Guido Castelli Gattinara',
    description: 'Direttore Scientifico',
    credentials: [
      'Pediatra e Infettivologo - Ospedale Pediatrico Bambino Gesù – IRCCS',
      'Docente Malattie Infettive – Università Roma Tor Vergata',
      'Presidente Società Italiana di Infettivologia Pediatrica',
    ],
    image: '/images/scientific_commitee/prof-guido-castelli-gattinara.jpg',
  },
  {
    name: 'Dr. Matteo Ferrari',
    description: 'Endocrinologo',
    credentials: [
      'Responsabile Medicina Interna - IRCCS Istituto Ortopedico Galeazzi',
    ],
    image: '/images/scientific_commitee/dr-matteo-ferrari.jpg',
  },
  {
    name: 'Dr.ssa Manuela Pastore',
    description: 'Nutrizionista',
    credentials: ['Istituto Clinico Humanitas'],
    image: '/images/scientific_commitee/drssa-manuela-pastore.jpg',
  },
  {
    name: 'Dr. Gianluca Ardolino',
    description: 'Neurologo',
    credentials: [`IRCCS Ca' Granda – Ospedale Maggiore Policlinico`],
    image: '/images/scientific_commitee/dr-gianluca-ardolino.jpg',
  },
  {
    name: 'Dr. Francesco Gesualdo',
    description: 'Pediatra e Ricercatore',
    credentials: ['Ospedale Pediatrico Bambino Gesù IRCCS'],
    image: '/images/scientific_commitee/dr-francesco-gesualdo.jpg',
  },
];
